import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api, eur, errMsg, img } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export default function AdminProducts() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/products", { params: { q } }).then((r) => setItems(r.data)), 250);
    return () => clearTimeout(t);
  }, [q]);

  const patch = async (p, body) => {
    try {
      const { data } = await api.put(`/admin/products/${p.id}`, body);
      setItems((xs) => xs.map((x) => (x.id === p.id ? { ...x, ...data } : x)));
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const create = async () => {
    try {
      const { data } = await api.post("/admin/products", { name: "Nuovo prodotto", price: 0 });
      nav(`/admin/prodotti/${data.id}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid="admin-products-page">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h1 className="font-display text-3xl font-semibold">Prodotti <span className="font-mono text-base text-slate-500">{items?.length ?? ""}</span></h1>
        <button onClick={create} data-testid="admin-new-product-btn" className="flex h-10 items-center gap-2 rounded-full bg-[#0066FF] px-5 text-sm font-medium"><Plus className="h-4 w-4" />Nuovo prodotto</button>
      </div>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca per nome, codice, categoria…" data-testid="admin-products-search"
        className="mt-6 h-11 w-full max-w-md rounded-xl border border-white/10 bg-white/5 px-4 text-sm outline-none focus:border-[#0066FF]" />
      <div className="mt-6 overflow-x-auto rounded-2xl border border-white/10">
        <table className="w-full min-w-[760px] text-sm" data-testid="admin-product-table">
          <thead className="bg-white/5 text-left font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            <tr><th className="p-3">Prodotto</th><th className="p-3">Categoria</th><th className="p-3">Prezzo</th><th className="p-3">Quantità</th><th className="p-3">Visibile</th><th className="p-3">In evidenza</th></tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {(items || []).map((p) => (
              <tr key={p.id} className="hover:bg-white/[0.03]" data-testid={`admin-product-row-${p.id}`}>
                <td className="p-3">
                  <Link to={`/admin/prodotti/${p.id}`} className="flex items-center gap-3 hover:text-[#7FB0FF]">
                    <span className="h-11 w-11 shrink-0 overflow-hidden rounded-lg bg-white">{p.images?.[0] && <img src={img(p.images[0].url)} alt="" className="h-full w-full object-contain p-0.5" />}</span>
                    <span className="line-clamp-2 max-w-xs">{p.name}</span>
                  </Link>
                </td>
                <td className="p-3 text-slate-400">{p.category_path || <span className="text-amber-300/80">—</span>}</td>
                <td className="p-3 font-mono">{eur(p.price)}</td>
                <td className="p-3 font-mono text-slate-400">{p.inventory_tracked ? p.quantity : "∞"}</td>
                <td className="p-3"><Switch checked={p.available} onCheckedChange={(v) => patch(p, { available: v })} data-testid={`admin-toggle-available-${p.id}`} /></td>
                <td className="p-3"><Switch checked={p.featured} onCheckedChange={(v) => patch(p, { featured: v })} data-testid={`admin-toggle-featured-${p.id}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
